import { salesDeskInventoryOrderFromOptions, type SalesDeskInventoryOrderInput } from "./salesDeskInventoryModel";

/** Building fields from documented ShedCor IdeaRoom orders. No customer identity. */
const DOCUMENTED_SHEDCOR_ORDERS: Array<{ id: string; options: Record<string, unknown> }> = [
  {
    id: "06000f2babcce076697861823edcd346",
    options: {
      supplier: "shedcor",
      style: "Classic Utility",
      width: "10'",
      length: "12'",
      siding_color: "Navajo White",
      trim_color: "Navajo White",
      roof_color: "Black",
      roof_material: "Metal",
      sku: "124585",
      total_price: 5631,
      line_items: [{ description: "Siding: LP Silvertech 7/16\" 8\" Groove", product_key: "siding" }],
    },
  },
  {
    id: "233d985d6074b205e722b95c83b6ca67",
    options: {
      supplier: "shedcor",
      style: "Basic Utility",
      width: "8'",
      length: "12'",
      siding_color: "Blue",
      trim_color: "Origami White",
      roof_color: "Galvalume",
      roof_material: "Metal",
      sku: "124543",
      total_price: 3905.8,
      line_items: [
        { description: "Siding: LP 3/8\" 8\" OC Groove", product_key: "siding" },
        { description: "Floor Joist: 2x4 - 12\" OC", product_key: "floor" },
      ],
    },
  },
  {
    id: "ec6d396faecbbb044a063f42dcbc0362",
    options: {
      supplier: "shedcor",
      style: "Basic Utility",
      width: "8'",
      length: "12'",
      siding_color: "Blue",
      trim_color: "Origami White",
      roof_color: "Galvalume",
      roof_material: "Metal",
      sku: "124543",
      total_price: 3968.2,
      line_items: [
        { description: "Siding: LP 3/8\" 8\" OC Groove", product_key: "siding" },
        { description: "Floor Joist: 2x6 - 16\" OC", product_key: "floor" },
      ],
    },
  },
];

export const SALES_DESK_SHEDCOR_ORDERS: SalesDeskInventoryOrderInput[] = DOCUMENTED_SHEDCOR_ORDERS.flatMap((order) => {
  const parsed = salesDeskInventoryOrderFromOptions(order.id, order.options);
  return parsed ? [parsed] : [];
});
